import ApiClient from './ApiClient';

class AppointmentServicesAPI extends ApiClient {
  constructor() {
    super('services', { accountScoped: true });
  }
}

export default new AppointmentServicesAPI();
